import Vue from "vue";
import Router from "vue-router";
import pay from "@/components/pay";
import index from "@/components/index";
import game from "@/components/game";
import gift from "@/components/gift";
import news from "@/components/news";
// import pay_mobile from '@/components/mobile/pay'
import index_mobile from "@/components/mobile/index";
import game_mobile from "@/components/mobile/game";
import gift_mobile from "@/components/mobile/gift";
import news_mobile from "@/components/mobile/news";

Vue.use(Router);

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location, resolve, reject) {
  if (resolve && reject) {    //如果传了回调函数，直接使用
    originalPush.call(this, location, resolve, reject);
}else {                     //如果没有传回调函数，手动添加
    originalPush.call(this, location, ()=>{}, ()=>{}); 
}
  // return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: index
    },
    {
      path: "/game",
      name: "game",
      component: game
    },
    {
      path: "/gift",
      name: "gift",
      component: gift
    },
    {
      path: "/news",
      name: "news",
      component: news
    },
    {
      path: "/pay",
      name: "pay",
      component: pay
    },
    {
      path: "/mobile/index",
      name: "index_mobile",
      component: index_mobile
    },
    {
      path: "/mobile/game",
      name: "game_mobile",
      component: game_mobile
    },
    {
      path: "/mobile/gift",
      name: "gift_mobile",
      component: gift_mobile
    },
    {
      path: "/mobile/news",
      name: "news_mobile",
      component: news_mobile
    }
    // {
    //   path: '/mobile/pay',
    //   name: 'pay_mobile',
    //   component: pay_mobile
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js